import { logout } from '../features/auth/authSlice';
import { clearCart } from '../features/cart/cartSlice';
import { clearMandateData } from '../features/paystack/mandateSlice';
import { clearUser } from '../features/user/userSlice';
import { queryClient } from '../main';
import { persistor } from '../store';

export const performLogout = () => async (dispatch) => {
  dispatch({ type: 'LOGOUT' });

  localStorage.removeItem('authToken');
  sessionStorage.clear();

  if (queryClient) queryClient.clear();

  await persistor.purge();

  window.location.reload();
};
